// extracted by mini-css-extract-plugin
export default {"description":"BlockClientModal_description__h3mdc"};